import { c as _c } from "react/compiler-runtime";
import { IconButton, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { VXButtons } from '../buttons/vxButtons';
export const RenameEntityName = t0 => {
  const $ = _c(18);
  const {
    name,
    label,
    onSubmit,
    bold: t1,
    editMode,
    setEditMode,
    focusOnMount: t2
  } = t0;
  const bold = t1 === undefined ? true : t1;
  const focusOnMount = t2 === undefined ? false : t2;
  const [internalEditMode, setInternalEditMode] = useState(editMode || focusOnMount);
  let t3;
  if ($[0] !== editMode || $[1] !== internalEditMode || $[2] !== setEditMode) {
    t3 = () => setEditMode ? editMode : internalEditMode;
    $[0] = editMode;
    $[1] = internalEditMode;
    $[2] = setEditMode;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const getEditMode = t3;
  let t4;
  if ($[4] !== setEditMode) {
    t4 = editMode_0 => setEditMode ? setEditMode(editMode_0) : setInternalEditMode(editMode_0);
    $[4] = setEditMode;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const setEditModeWrapper = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      alignItems: "center",
      gap: "4px"
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== label) {
    t6 = label && <Typography className="mr-[20px]">{label}</Typography>;
    $[7] = label;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== bold || $[10] !== getEditMode || $[11] !== name || $[12] !== onSubmit || $[13] !== setEditModeWrapper) {
    t7 = !getEditMode() ? <Stack direction="row" sx={{
      alignItems: "center",
      gap: "8px"
    }}><Typography className={bold ? "font-semibold" : ""}>{name}</Typography><IconButton onClick={() => setEditModeWrapper(true)} data-testid="rename-entity-name-edit-btn"><i className="material-symbols-stylus-outline w-[20px] h-[20px] text-(--mui-palette-text-primary)" /></IconButton></Stack> : <EditEntityName initialName={name} onSubmit={onSubmit} onClose={() => setEditModeWrapper(false)} />;
    $[9] = bold;
    $[10] = getEditMode;
    $[11] = name;
    $[12] = onSubmit;
    $[13] = setEditModeWrapper;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <Stack direction="row" sx={t5}>{t6}{t7}</Stack>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export const EditEntityName = t0 => {
  const $ = _c(24);
  const {
    initialName,
    onSubmit,
    onClose
  } = t0;
  const [newName, setNewName] = useState(initialName);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "center",
      gap: "12px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== newName) {
    t2 = validateName(newName);
    $[1] = newName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = !t2;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      htmlInput: {
        "data-testid": "rename-entity-name-input"
      }
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = e_0 => setNewName(e_0.target.value);
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== newName || $[6] !== t3) {
    t6 = <TextField autoFocus={true} onFocus={_temp} error={t3} slotProps={t4} value={newName} onChange={t5} />;
    $[5] = newName;
    $[6] = t3;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== newName || $[9] !== onClose || $[10] !== onSubmit) {
    t7 = () => {
      onClose();
      onSubmit(newName);
    };
    $[8] = newName;
    $[9] = onClose;
    $[10] = onSubmit;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== initialName || $[13] !== onClose) {
    t8 = () => {
      onClose();
      setNewName(initialName);
    };
    $[12] = initialName;
    $[13] = onClose;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== newName) {
    t9 = validateName(newName);
    $[15] = newName;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = !t9;
  let t11;
  if ($[17] !== t10 || $[18] !== t7 || $[19] !== t8) {
    t11 = <VXButtons onApprove={t7} onCancel={t8} approveDisabled={t10} />;
    $[17] = t10;
    $[18] = t7;
    $[19] = t8;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t6) {
    t12 = <Stack direction="row" sx={t1}>{t6}{t11}</Stack>;
    $[21] = t11;
    $[22] = t6;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};
export const validateName = (name = '') => name.trim().length >= 4;
function _temp(e) {
  return e.target.select();
}